document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('#country')) {

        const countrySelect = new SlimSelect({select: '#country', events: {
            afterChange: (newVal) => {
            let checkout = document.querySelector('form.kickstart');
            if(newVal == "GB-ENG" || newVal == 'GB-WLS') {
                checkout.classList.remove('international');
                checkout.classList.add('local');
                document.querySelector('#international_school_lookup').removeAttribute('required');
            } else {
                checkout.classList.add('international');
                checkout.classList.remove('local');
                document.querySelector('#school_lookup').removeAttribute('required');
            }
            }
        }});
        window.countrySelect = countrySelect;
    }

    if(document.querySelector('#international_school_lookup')) {

        const intSchoolSelect = new SlimSelect({
            select: '#international_school_lookup',
            settings: {
                searchPlaceholder: 'Please enter 3 or more characters',
                placeholderText: 'Enter School Name or Postcode'
            }, events: {
                afterChange: (newVal) => {
                    updateIntFields(newVal)
                },
                search: (search, currentData) => {
                    let country = document.querySelector('#country').value;

                    return new Promise((resolve, reject) => {
                        if (search.length < 3) {
                            return reject('Please enter 3 or more characters')
                        }
                        let formdata = new FormData();
                        formdata.append('action', 'international_school_lookup');
                        formdata.append('q', search);
                        formdata.append('c', country);
                        const url = ta_admin.ta_ajax_url;
                        fetch(url, {
                            method: 'POST',
                            body: formdata
                        })
                        .then((response) => response.json())
                        .then((results) => {
                            const data = results?.records || [];
                             if (!data.length) {
                                return reject(results?.error || 'No results found')
                            }
                            const options = data.map((school) => {
                                return {
                                    text: `${school.EstablishmentName} ${school.Street}, ${school.Town}, ${school.Postcode}`,
                                    value: `${school.URN}`,
                                    html: `<b>${school.EstablishmentName}</b><span style="display: block">${school.Street}, ${school.Town}, ${school.Postcode}</span>`,
                                    data: school
                                }
                            })

                            resolve([{ label: 'Results', selectAll: true, options: options }])
                        })
                        .catch((error) => {
                            console.log(error)
                            reject('Error fetching results')
                        })
                    })
                }
            }
        })
    }
    if(document.querySelector('#school_lookup')) {

        const schoolSelect = new SlimSelect({
            select: '#school_lookup',
            settings: {
                searchPlaceholder: 'Please enter 3 or more characters',
                placeholderText: 'Enter School Name or Postcode'
            }, events: {
                afterChange: (newVal) => {
                    updateFields(newVal)
                },
                search: (search, currentData) => {
                    let country = document.querySelector('#country').value;
                    let ToE = returnTOE(country);


                    return new Promise((resolve, reject) => {
                        if (search.length < 3) {
                            return reject('Please enter 3 or more characters')
                        }
                        const data = determineData(search, ToE)
                        const queryParams = new URLSearchParams(data);
                        const url = `https://schools.igoodev.com/api/records/schools?${queryParams}`;

                        fetch(url, {method: 'GET', headers: {
                            'Content-Type': 'application/json'
                        }})
                        .then((response) => response.json())
                        .then((resp) => {
                            const data = resp?.records || []
                            if (!data.length) {
                                return reject(resp?.error || 'No results found')
                            }
                            const options = data.filter((school) => {
                                return (school.EstablishmentStatus == 'Open' || school.EstablishmentStatus == 'Proposed to open') && !currentData.some((dataItem) => {
                                return dataItem instanceof Option &&
                                    dataItem.value === `${school.URN}`
                                })
                            }).map((school) => {
                                return {
                                    text: `${school.EstablishmentName} ${school.Street}, ${school.Town}, ${school.Postcode}`,
                                    value: `${school.URN}`,
                                    html: `<b>${school.EstablishmentName}</b><span style="display: block">${school.Street}, ${school.Town}, ${school.Postcode}</span>`,
                                    data: school
                                }
                            })

                            resolve([{ label: 'Results', selectAll: true, options: options }])
                        })
                        .catch((error) => {
                            console.log(error)
                            reject('Error fetching results')
                        })
                    })
                }
            }
        })
    }


    /** Email Validate */

    let emailInput = document.querySelector('#email_address');
    if(emailInput) {
        emailInput.addEventListener('change', maybeShowEmailWarning);
    }

    function maybeShowEmailWarning(e) {
        let val = e.target.value;
        let valid = true;
        let inValid = ['gmail.com', 'hotmail.co', 'msn.co', 'yahoo.co', 'aol.co', 'icloud.co'];
        inValid.forEach((i) => {
            if(val.indexOf(i) !== -1) {
                valid = false;
            }
        });
        if(!valid) {
            e.target.parentElement.querySelector('p').classList.remove('hidden');
        } else {
            e.target.parentElement.querySelector('p').classList.add('hidden');
        }
    }

    /**
     * checkout
     */


    let passwordInput = document.querySelector('.checkout #account_password');
    if(passwordInput) {
        passwordInput.addEventListener('keyup', checkPasswordStrength);
    }


    function validateField(i) {
        let type = i.type;
        if(type == 'password') {
            // set some password restrictions
            return checkPasswordStrength(i, true);
        }
        // do some other checking?
        return i.checkValidity();
    }

    function checkPasswordStrength(i, direct = false) {
        let $strengthResult = document.querySelector('#password-strength');
        if(!direct) {
            i = i.target;
        }
        var strength = wp.passwordStrength.meter( i.value, [], i.value );
        let proceed = false;
        switch ( strength ) {
            case 2:
                $strengthResult.classList.add( 'bad' )
                $strengthResult.innerHTML =  pwsL10n.bad + ' password' ;
                i.parentElement.classList.add('error');
                break;
            case 3:
                $strengthResult.classList.add( 'good' )
                $strengthResult.innerHTML =  pwsL10n.good + ' password' ;
                proceed = true;
                break;
            case 4:
                $strengthResult.classList.add( 'strong' )
                $strengthResult.innerHTML =  pwsL10n.strong + ' password' ;
                proceed = true;
                break;
            case 5:
                $strengthResult.classList.add( 'short' )
                $strengthResult.innerHTML =  pwsL10n.mismatch + ' password' ;
                i.parentElement.classList.add('error');
                break;
            default:
                $strengthResult.classList.add( 'short' )
                $strengthResult.innerHTML =  pwsL10n.short + ' password' ;
                i.parentElement.classList.add('error');
        }
        return proceed;
    }

    let toggleAdditionalSchoolFields = document.querySelector('.toggle-additional-school-fields');
    if(toggleAdditionalSchoolFields) {
        toggleAdditionalSchoolFields.addEventListener('click', showAdditionalSchoolFields)
    }

    function showAdditionalSchoolFields(e) {
        e.preventDefault();
        let fields = document.querySelectorAll('.school-alternate-fields .form-col');

        fields.forEach(i => {
            i.classList.remove('hidden');
            i.querySelector('input').setAttribute('type', 'text');
        });
        document.querySelector('.school-alternate-fields').classList.remove('hidden');
    }

    // main checkout process

    let checkoutForm = document.querySelector('form.kickstart');
    if(checkoutForm) {
        checkoutForm.addEventListener('submit', submit_kickstart_checkout);
    }


    function submit_kickstart_checkout(e) {
        e.preventDefault();
        checkoutForm.querySelector('.notices').innerText = '';
        e.target.parentElement.classList.add('submitting');
        if(e.target.classList.contains('international')) {
            document.querySelector('#school_urn').value = 'INT' + Date.now();
        }
        let formdata = new FormData(e.target);

        formdata.append('action', 'submit_kickstart_checkout');

        fetch(sc_front.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then((response => response.json()))
        .then((jsonData) => {
            if(jsonData.success) {
                window.location = '/order-received/'
            } else {
                checkoutForm.querySelector('.notices').innerText = jsonData.message;
            }
        });
    }

    let activelearningform = document.querySelector('form.active-learning');
    if(activelearningform) {
        activelearningform.addEventListener('submit', submit_active_learning);
    }

    function submit_active_learning(e) {
        e.preventDefault();
        activelearningform.querySelector('.notices').innerText = '';
        e.target.parentElement.classList.add('submitting');
        if(e.target.classList.contains('international')) {
            document.querySelector('#school_urn').value = 'INT' + Date.now();
        }
        let formdata = new FormData(e.target);

        formdata.append('action', 'submit_active_learning_pack');

        fetch(sc_front.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then((response => response.json()))
        .then((jsonData) => {
            if(jsonData.success) {
                window.location = '/active-learning-pack/?submitted=true';
            } else {
                checkoutForm.querySelector('.notices').innerText = jsonData.message;
            }
        });
    }

});

function getSchoolDetails(e) {
    if(e.target.getAttribute('data-school-id')) {
        document.querySelector('.form-container').classList.add('submitting');
        let id = e.target.getAttribute('data-school-id')
        let formdata = new FormData();
        formdata.append('school_id', id);
        formdata.append('action', 'get_existing_school_for_checkout');
        fetch(sc_front.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then((response => response.json()))
        .then((jsonData) => {
            if(jsonData) {
                jsonData.forEach((i) => {
                    let keys = Object.keys(i);
                    keys.forEach((j) => {
                        if(j == 'ADDRESS_BILLING_COUNTRY') {
                            console.log(i[j])
                            window.countrySelect.setSelected(i[j])
                            let label = document.querySelector('option[value="'+i[j]+'"]').innerText
                            let labelTargets = document.querySelectorAll('.country-container .ss-single');
                            labelTargets.forEach((i) => { i.innerText = label})
                        }
                        if(document.querySelector('[data-insightly-lookup="'+j+'"]')) {
                            if(i[j]) {
                                document.querySelector('[data-insightly-lookup="'+j+'"]').value = i[j];
                            }
                        }
                        if(typeof i[j] == 'object' && j == 'CUSTOMFIELDS') {
                            let innerKeys = Object.keys(i[j]);
                            innerKeys.forEach((k) => {
                                if(document.querySelector('[data-insightly-lookup="'+k+'"]')) {
                                    console.log(j, k, i[j][k])
                                    if(i[j][k]) {
                                        document.querySelector('[data-insightly-lookup="'+j+'"]').value = i[j];
                                    }
                                }
                            })
                        }
                    })
                })
            }
            document.querySelector('.form-container').classList.remove('submitting');
        });
    }
}
window.getSchoolDetails = getSchoolDetails;

function determineData(term, ToE) {
    return 'transform=1&&satisfy=any&filter1[]=EstablishmentName,cs,'+term+'&filter1[]='+ToE+'&filter2[]=Postcode,sw,'+term+'&filter2[]='+ToE;
}

function updateFields(data) {
    let dataArr = Object.entries(data[0].data);
    dataArr.forEach(val => {
        if(document.querySelector('[data-lookup="'+val[0]+'"]')) {
            document.querySelector('[data-lookup="'+val[0]+'"]').value = val[1];
        }
    });
}

function updateIntFields(data) {
    let dataArr = Object.entries(data[0].data);
    dataArr.forEach(val => {
        console.log(val);
        if(document.querySelector('[data-lookup="'+val[0]+'"]')) {
            document.querySelector('[data-lookup="'+val[0]+'"]').value = val[1];
        }
    })
}


function returnTOE(val) {
    switch (val) {
        case 'GB-WLS':
            return 'TypeOfEstablishment,eq,Welsh establishment';
            break;

        case 'GB-ENG':
            return 'TypeOfEstablishment,neq,British schools overseas','TypeOfEstablishment,neq,Welsh establishment';
            break;

        default:
            return '';
            break;

    }
}
